export enum FulfillmentStepStatusType {
  Pending = "Pending",
  Scheduled = "Scheduled",
  Dispatched = "Dispatched",
  Completed = "Completed",
  Failed = "Failed",
  OnHold = "OnHold",
  Canceled = "Canceled",
  Splitted = "Splitted",
}
